import { io, Socket } from 'socket.io-client';

// ============================================================
// Client Socket.IO per comunicazione real-time con il backend
// ============================================================

// In produzione usa l'origin della pagina (nginx proxy /socket.io → backend)
// In dev usa VITE_SOCKET_URL o localhost:4000
const SOCKET_URL =
  import.meta.env.VITE_SOCKET_URL ??
  (import.meta.env.PROD ? window.location.origin : 'http://localhost:4000');

let socket: Socket | null = null;

/**
 * Connette il client Socket.IO con il token JWT per l'autenticazione.
 * Se gia' connesso, restituisce la connessione esistente.
 */
export function connectSocket(token: string): Socket {
  if (socket?.connected) return socket;

  socket = io(SOCKET_URL, {
    auth: { token },
    transports: ['websocket', 'polling'],
    reconnection: true,
    reconnectionAttempts: 10,
    reconnectionDelay: 1000,
    reconnectionDelayMax: 5000,
  });

  socket.on('connect', () => {
    console.log('[Socket] Connected:', socket?.id);
  });

  socket.on('disconnect', (reason) => {
    console.log('[Socket] Disconnected:', reason);
  });

  socket.on('connect_error', (err) => {
    console.warn('[Socket] Connection error:', err.message);
  });

  return socket;
}

/**
 * Disconnette il client Socket.IO e pulisce il riferimento.
 */
export function disconnectSocket() {
  if (socket) {
    socket.disconnect();
    socket = null;
  }
}

/**
 * Restituisce l'istanza socket attiva, o null se non connessa.
 */
export function getSocket(): Socket | null {
  return socket;
}

/**
 * Richiede l'iscrizione a una room sul server (es. 'project:123', 'event:456').
 */
export function joinRoom(room: string) {
  socket?.emit('join:room', room);
}

/**
 * Richiede l'uscita da una room sul server.
 */
export function leaveRoom(room: string) {
  socket?.emit('leave:room', room);
}
